<app-gradient-header>
  <h1>Factures et moyen de paiement de la clinique : {{ clinic?.name }}</h1>
</app-gradient-header>
<div class="container" *ngIf="paymentMethod">
  <div class="secure-payment-banner">
    <mat-icon>lock</mat-icon>
    <span>
      <strong>Paiement 100 % sécurisé.</strong> Vos données bancaires sont chiffrées et ne sont ni connues ni stockées sur nos serveurs.
      Transactions traitées par Stripe (Certifié PCI DSS Niveau 1).
    </span>
  </div>

  <section>
    <h2>Factures</h2>

    <p class="billing-recap">
      <span>Le montant du dépôt d'une étude sera ajouté au prix de l'abonnement Stripe, prélevé au début du mois suivant.</span>
      <button mat-icon-button type="button" class="info-button"
        (click)="openPaymentProcessInfo()"
        aria-label="Détails du processus de paiement"
        matTooltip="En savoir plus sur le paiement via Stripe">
        <mat-icon fontSet="material-icons-outlined">info</mat-icon>
      </button>
    </p>

    <p *ngIf="nextInvoiceAmount !== undefined">
      Montant de votre prochaine facture : <strong>{{ nextInvoiceAmount | currency:'EUR' }}</strong>
    </p>

    <div>
      <button mat-raised-button color="accent" (click)="openStripe()">Voir les factures sur Stripe</button>
    </div>
  </section>

  <section>
    <div *ngIf="paymentMethod.hasMethod">
      <h2>Moyen de paiement utilisé</h2>
      <p>Le moyen de paiement ci-dessous est actuellement utilisé pour les envoi d'études</p>
      <p class="error" *ngIf="!paymentMethod.valid">Il est actuellement invalide !</p>
      <div class="card" *ngIf="paymentMethod.isCard; else sepaTemplate">
        <div class="brand">{{ paymentMethod.brand | titlecase }}</div>
        <div class="card-infos">
          <div>•••• •••• •••• {{ paymentMethod.last4 }}</div>
          <div class="expires">Expire le {{ paymentMethod.expMonth }}/{{paymentMethod.expYear }}</div>
        </div>
      </div>
      <ng-template #sepaTemplate>
        <div class="sepa">
          <p>
            Prélèvement SEPA se terminant par <b>{{ paymentMethod.last4 }}</b>
            <br>
            Code banque : <b>{{ paymentMethod.bankCode }}</b>
          </p>
        </div>
      </ng-template>
    </div>

    <div>
      <h2>Modifier le moyen de paiement</h2>
      <p>Le moyen de paiement ajouté ici sera utilisé pour les futurs envois d'études</p>
      <app-scc-payment-method-input></app-scc-payment-method-input>
    </div>
  </section>
</div>
